module.exports = __webpack_public_path__ + "static/media/pptx.5f3c4cf8.svg";